export default __webpack_public_path__ + "static/media/zawodnik7.fa069f0f.png";